import template from './template.html';
import controller from './controller';

const adminEmployeesProfileState = {
  url: '/profile?first&last&email&department&level&locations&practices&pagination&page&pageSize&sortType&tags',
  stateName: 'User Manager',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: true,
  params: {
    email: {
      value: undefined,
      type: 'string'
    },
    first: {
      value: undefined,
      type: 'string'
    },
    last: {
      value: undefined,
      type: 'string'
    },
    department: {
      value: undefined,
      type: 'json',
      squash: true
    },
    level: {
      value: undefined,
      type: 'json',
      squash: true
    },
    locations: {
      value: undefined,
      type: 'json',
      squash: true
    },
    practices: {
      value: undefined,
      type: 'json',
      squash: true
    },
    page: {
      type: 'int',
      value: undefined
    },
    pageSize: {
      type: 'int',
      value: undefined
    },
    sortType: {
      type: 'string',
      value: undefined
    },
    tags: {
      value: undefined,
      array: true,
      type: 'string',
      squash: true
    }
  },
  views: {
    'a@app': {
      template,
      controller,
      controllerAs: 'AdminEmployeesCtrl'
    }
  }
};

export { adminEmployeesProfileState };



// WEBPACK FOOTER //
// ./src/app/controllers/admin/employees/index.js